export default __webpack_public_path__ + "static/media/paymentX.7d5c6923.svg";